import {
  constantesRequerimentos,
  cpfResponsavelValido,
  getFormatedDate,
} from '@utils';
import { differenceInYears } from 'date-fns';
import * as yup from 'yup';

const { CONJUGADA_S_R_RCM, TEMPORARIA_VARIAVEL, CONJUGADA_C_R_RCM } =
  constantesRequerimentos;

export const plano = (required = false) => {
  return required
    ? {
        plano: yup.string().required('Atenção, Selecione a opção Plano'),
      }
    : {
        plano: yup.string(),
      };
};

export const nomeBeneficiario = {
  nomeBeneficiario: yup
    .string()
    .required('Atenção, Preencha o Nome completo do (a) Beneficiário'),
};

export const cpf = {
  cpf: yup
    .string()
    .cpf('Atenção, Insira um CPF válido no campo CPF.')
    .required('Atenção, insira um CPF.'),
};

export const acao = {
  acao: yup.string().required('Atenção, seleciona a ação.'),
};

export const cpfResponsavelLegal = {
  cpfResponsavelLegal: yup
    .string()
    .cpf('Atenção, Insira um CPF válido no campo CPF.'),
};

export const nascimento = {
  nascimento: yup
    .date()
    .max(getFormatedDate(new Date().toLocaleDateString('pt')))
    .required('Atenção, Data da nascimento inválida.'),
};

export const nomeMaeBeneficiario = {
  nomeMaeBeneficiario: yup.string().when('acao', {
    is: (value) => value !== 'Excluir',
    then: (field) =>
      field.required(
        'Atenção, Preencha o Nome completo da Mãe do Beneficiário'
      ),
  }),
};

export const nomePaiBeneficiario = { nomePaiBeneficiario: yup.string() };

export const cpfBeneficiario = {
  cpf: yup.string().when('acao', {
    is: (value) => value !== 'Excluir',
    then: (field) =>
      field
        .cpf('Atenção, Insira um CPF válido no campo CPF.')
        .required('Atenção, insira um CPF.'),
  }),
};

export const nascimentoBeneficiario = {
  nascimento: yup.date().when('acao', {
    is: (value) => value !== 'Excluir',
    then: (field) =>
      field
        .max(getFormatedDate(new Date().toLocaleDateString('pt')))
        .required('Atenção, Data da nascimento inválida.'),
  }),
};

export const parentescoBeneficiario = {
  parentesco: yup.string().when('acao', {
    is: (value) => value !== 'Excluir',
    then: (field) => field.required('Atenção, Selecione o Parentesco'),
  }),
};
export const parentesco = {
  parentesco: yup.string().required('Atenção, Selecione o Parentesco'),
};

export const rulesSituationParents = [
  'Filho(a)',
  'Enteado(a)',
  'Irmão(ã)',
  'Neto(a)',
  'Bisneto(a)',
];

export const rulesSituationParentsBeneficiarios = ['Filho(a)', 'Enteado(a)'];

export const situacaoParentesco = {
  situacaoParentesco: yup.string().when('acao', {
    is: (value) => value !== 'Excluir',
    then: yup.string().when('parentesco', {
      is: (value) => rulesSituationParents.includes(value),
      then: yup.string().required('Atenção, Preencha o campo Situação'),
      otherwise: yup.string().nullable(),
    }),
    otherwise: yup.string().nullable(),
  }),
};
export const situacaoParentescoBeneficiario = {
  situacaoParentesco: yup.string().when('acao', {
    is: (value) => value !== 'Excluir',
    then: yup.string().when('parentesco', {
      is: (value) => rulesSituationParentsBeneficiarios.includes(value),
      then: yup.string().required('Atenção, Preencha o campo Situação'),
      otherwise: yup.string().nullable(),
    }),
    otherwise: yup.string().nullable(),
  }),
};
/**
 * Retorna regra para médicos(perito e assistente).
 *
 * @param {string} medico Valores: 'medicoPerito' | 'medicoAssistente'.
 * @param {boolean} required Se apenas requerido (true), senão requerido com regra
 * @param {boolean} isBeneficiarioDependente Se apenas requerido (true), Não é obrigatório no formulário
 * @return Regra yup a ser desestruturada dentro de um objeto yup.
 */
export const medicos = (medico, required, isBeneficiarioDependente = false) => {
  if (isBeneficiarioDependente) {
    return {
      [medico]: yup
        .string()
        .when(['parentesco', 'acao', 'situacaoParentesco'], {
          is: (parentescoField, acaoField, situacaoField) =>
            acaoField !== 'Excluir' &&
            (parentescoField === 'Filho(a)' ||
              parentescoField === 'Enteado(a)') &&
            situacaoField === 'Com invalidez',
          then: yup.string().required('Atenção, Selecione o médico.'),
          otherwise: yup.string().nullable(),
        }),
    };
  }

  return required
    ? {
        [medico]: yup.string().required('Atenção, Selecione o médico.'),
      }
    : {
        [medico]: yup.string().when('parentesco', {
          is: (parente) => parente === 'Filho(a) especial',
          then: yup.string().required('Atenção, Selecione o médico.'),
        }),
      };
};

export const consentimentoDadosSensiveisBeneficiario = {
  consentimentoDadosSensiveis: yup.bool().when('acao', {
    is: (value) => value !== 'Excluir',
    then: yup.bool().oneOf([true], 'Atenção, Clique em Consentir'),
  }),
};

export const consentimentoDadosSensiveis = (validarMaiorIdade) => {
  return validarMaiorIdade
    ? {
        consentimentoDadosSensiveis: yup
          .bool()
          .oneOf([true], 'Atenção, Clique em Consentir')
          .when('nascimento', {
            is: (dataNasc) => {
              const idade = differenceInYears(new Date(), dataNasc);

              return idade >= 18;
            },
            then: yup.bool().oneOf([true, false]),
          }),
      }
    : {
        consentimentoDadosSensiveis: yup
          .bool()
          .oneOf([true], 'Atenção, Clique em Consentir'),
      };
};

export const nomeDoTutor = {
  nomeDoTutor: yup.string().when('cpfResponsavelLegal', {
    is: (cpfRespLegal) => cpfResponsavelValido(cpfRespLegal),
    then: (field) =>
      field.required(
        'Atenção, Preencha o campo Nome do(a) Tutor(a)/Responsável Legal'
      ),
  }),
};

export const optoPor = {
  optoPor: yup.string().required('Atenção, Selecione a opção Opto por'),
};

export const adiantamentoQuinzenal = {
  adiantamentoQuinzenal: yup
    .string()
    .required('Atenção, Selecione a opção adiantamento quinzenal'),
};

export const adiantamentoQuinzenalCondicional = {
  adiantamentoQuinzenal: yup.string().when('optoPor', {
    is: 'Continuar a receber o último percentual escolhido pelo participante',
    then: (field) =>
      field.required('Atenção, Selecione a opção adiantamento quinzenal'),
  }),
};

export const parcelaAVistaCondicional = {
  parcelaAVista: yup.string().when('optoPor', {
    is: 'Continuar a receber o último percentual escolhido pelo participante',
    then: (field) =>
      field
        .oneOf(['Sim', 'Não'])
        .required('Atenção, Selecione a opção Parcela à Vista'),
  }),
};

export const retiradaAVistaCondicional = {
  retiradaAVista: yup
    .number()
    .float(2, 'Máximo de duas casas decimais após a vírgula')
    .when('parcelaAVista', {
      is: 'Sim',
      then: (field) =>
        field
          .min(0.01, 'Valor deve estar entre 0,01 e 30')
          .max(30, 'Valor deve estar entre 0,01 e 30')
          .required('Atenção, Preencha o Percentual retirada à vista'),
    }),
};

export const acessoContraCheque = {
  acessoContraCheque: yup
    .string()
    .required('Atenção, Selecione a opção acesso ao contracheque'),
};

export const acessoInformeDeRendimentos = {
  acessoInformeDeRendimentos: yup
    .string()
    .required('Atenção, Informe Acesso ao  informe de rendimentos via'),
};

export const acessoJornalForluz = {
  acessoJornalForluz: yup
    .string()
    .required('Atenção, Selecione a opção de acesso ao Jornal Forluz'),
};

export const consentimentoDescontoFolha = {
  consentimentoDescontoFolha: yup
    .bool()
    .oneOf([true], 'Atenção, Clique em Consentir')
    .required('Atenção, Clique em Consentir'),
};
export const declaracaoVeracidade = {
  declaracaoVeracidade: yup
    .bool()
    .oneOf([true], 'Atenção, Clique em Consentir')
    .required('Atenção, Clique em Consentir'),
};
export const consentimentoAjustePagamento = {
  consentimentoAjustePagamento: yup
    .bool()
    .oneOf([true], 'Atenção, Clique em Consentir')
    .required('Atenção, Clique em Consentir'),
};
export const consentimentoAcertoFinanceiro = {
  consentimentoAcertoFinanceiro: yup
    .bool()
    .oneOf([true], 'Atenção, Clique em Consentir')
    .required('Atenção, Clique em Consentir'),
};

export const consentimentoBeneficio = {
  consentimentoBeneficio: yup.bool().when('opcaoBeneficio', {
    is: (value) =>
      [TEMPORARIA_VARIAVEL, CONJUGADA_S_R_RCM, CONJUGADA_C_R_RCM].includes(
        value
      ),
    then: (field) =>
      field.oneOf([true]).required('Atenção, Clique em Consentir'),
  }),
};

export const estaAposentadoINSS = {
  estaAposentadoINSS: yup
    .string()
    .oneOf(['Sim', 'Não'])
    .required('Atenção Selecione a opção Está aposentado pelo INSS?'),
};

export const houveProcessoJudicial = {
  houveProcessoJudicial: yup.string().when('estaAposentadoINSS', {
    is: 'Sim',
    then: yup
      .string()
      .required('Atenção Selecione a opção Houve processo judicial?'),
  }),
};

/**
 * Retorna regra para 'foiJulgado'.
 *
 * @param {boolean} houveProcesso Se true, condição 'houveProcessoJudicial'. Se false 'revisaoProcessoJudicial'.
 * @return Regra yup a ser desestruturada dentro de um objeto yup.
 */
export const foiJulgado = (houveProcesso = false) => {
  return houveProcesso
    ? {
        foiJulgado: yup.string().when('houveProcessoJudicial', {
          is: 'Sim',
          then: yup
            .string()
            .required('Atenção Selecione a opção Transitou em Julgado?'),
        }),
      }
    : {
        foiJulgado: yup.string().when('revisaoProcessoJudicial', {
          is: 'Sim',
          then: (field) =>
            field
              .oneOf(['Sim', 'Não'])
              .required('Atenção, Selecione a opção Transitou em Julgado?'),
        }),
      };
};

export const matricula = {
  matricula: yup.number().required('Preencha o campo matricula'),
};

export const nome = {
  nome: yup.string().required('Preencha o campo nome'),
};

export const tipoInstituto = {
  tipoInstituto: yup.string(),
};

export const opcao = {
  opcao: yup.string(),
};

export const autor = {
  autor: yup.string().required('Preencha o campo autor'),
};

export const saldo = {
  saldo: yup.string().required('Preencha o campo saldo'),
};

export const custeioAdm = {
  custeioAdm: yup.string().required('Preencha o campo Custeio Administrativo'),
};

export const aceite = {
  aceite: yup.bool().oneOf([true], 'Aceite a declaração').required(),
};

export const aceiteCienciaExclusao = {
  aceiteCienciaExclusao: yup.bool().when('acao', {
    is: (value) => value === 'Excluir',
    then: yup.bool().oneOf([true], 'Atenção, Aceite a declaração de exclusão'),
  }),
};

export const tipoRegime = {
  tipoRegime: yup
    .string()
    .required('Atenção, Clique em uma opção de regime tributário'),
};

export const salarioRealDeContribuicao = {
  salarioRealDeContribuicao: yup.string().required('Preencha o SRC'),
};

export const contribuicaoParticipante = {
  contribuicaoParticipante: yup
    .string()
    .required('Preencha a Contribuição do Participante'),
};

export const contribuicaoPatrocinador = {
  contribuicaoPatrocinador: yup
    .string()
    .required('Preencha a contribuição do Patrocinador'),
};

export const contribuicaoTotal = {
  contribuicaoTotal: yup.string().required('Preencha a contruição total'),
};

export const termosDePortabilidade = {
  termosDePortabilidade: yup
    .bool()
    .oneOf([true], 'Aceite os termos')
    .required('Aceite os termos'),
};

export const parcelaAVista = {
  parcelaAVista: yup
    .string()
    .oneOf(['Sim', 'Não'])
    .required('Atenção, Selecione a opção Parcela à Vista'),
};

export const parcelaAVistaObrigatoria = {
  parcelaAVista: yup
    .string()
    .oneOf(['Sim', 'Não'], 'Atenção, Selecione a opção Parcela à Vista')
    .required('Atenção, Selecione a opção Parcela à Vista'),
};

export const retiradaAVista = {
  retiradaAVista: yup
    .number()
    .float(2, 'Máximo de duas casas decimais após a vírgula')
    .when('parcelaAVista', {
      is: 'Sim',
      then: (field) =>
        field
          .min(0.01, 'Valor deve estar entre 0,01 e 50')
          .max(50, 'Valor deve estar entre 0,01 e 50')
          .required('Atenção, Preencha o Percentual retirada à vista'),
    }),
};

/**
 * Retorna regra para 'LimitePorcentagemSaqueAvista'.
 *
 * @param {number} LimitePorcentagemSaqueAvista valores de 30 até 50.
 * @return Regra yup a ser desestruturada dentro de um objeto yup.
 */
export const retiradaAVistaMAT = (LimitePorcentagemSaqueAvista) => {
  return {
    retiradaAVista: yup
      .number()
      .float(2, 'Máximo de duas casas decimais após a vírgula')
      .when('parcelaAVista', {
        is: 'Sim',
        then: (field) =>
          field
            .min(
              0.01,
              `Valor deve estar entre 0,01 e ${LimitePorcentagemSaqueAvista}`
            )
            .max(
              LimitePorcentagemSaqueAvista,
              `Valor deve estar entre 0,01 e ${LimitePorcentagemSaqueAvista}`
            )
            .required('Atenção, Preencha o Percentual retirada à vista'),
      }),
  };
};

export const boletoEmprestimoDinamico = (saldoDevedor) => {
  if (saldoDevedor) {
    return {
      boletoEmprestimo: yup.string().when('parcelaAVista', {
        is: 'Sim',
        then: (field) => field.required('Requerido'),
      }),
    };
  }

  return { boletoEmprestimo: yup.string() };
};

export const retiradaAVista30 = {
  retiradaAVista: yup
    .number()
    .float(2, 'Máximo de duas casas decimais após a vírgula')
    .when('parcelaAVista', {
      is: 'Sim',
      then: (field) =>
        field
          .min(0.01, 'Valor deve estar entre 0,01 e 30')
          .max(30, 'Valor deve estar entre  0,01 e 30')
          .required('Atenção, Preencha o Percentual retirada à vista'),
    }),
};

export const abatimentoDoEmprestimo = {
  abatimentoDoEmprestimo: yup
    .string()
    .oneOf(['Antecipação', 'Amortização'])
    .required('Validar se existe saldo devedor de empréstimo'),
};

export const boletoEmprestimo = {
  boletoEmprestimo: yup.string(),
};

export const boletoEmprestimoObrigatorio = {
  boletoEmprestimo: yup.string().when('parcelaAVista', {
    is: 'Sim',
    then: (field) => field.required('Requerido'),
  }),
};

export const abatimentoDoEmprestimoCondicional = {
  abatimentoDoEmprestimo: yup.string().when('boletoEmprestimo', {
    is: 'Não',
    then: (field) =>
      field
        .oneOf(
          ['Antecipação', 'Amortização'],
          'Validar se existe saldo devedor de empréstimo'
        )
        .required('Validar se existe saldo devedor de empréstimo'),
  }),
};

export const dataAposentadoria = {
  dataAposentadoria: yup
    .date()
    .max(getFormatedDate(new Date().toLocaleDateString('pt')))
    .when('estaAposentadoINSS', {
      is: 'Sim',
      then: (field) =>
        field.required('Atenção,Preencha o campo Data da aposentadoria'),
    }),
};

export const numeroDoBeneficio = {
  numeroDoBeneficio: yup
    .string()
    .matches(/[0-9]+/)
    .when('estaAposentadoINSS', {
      is: 'Sim',
      then: (field) =>
        field.required('Atenção, Preencha o campo Número do benefício'),
    }),
};

export const molestiaGrave = {
  molestiaGrave: yup
    .string()
    .oneOf(['Sim', 'Não'])
    .required('Atenção, Selecione a opção Acometido(a) por moléstia grave'),
};

export const parcelasDoPagamento = {
  parcelasDoPagamento: yup
    .string()
    .oneOf([
      'Parcela única',
      '2 parcelas mensais e sucessivas',
      '3 parcelas mensais e sucessivas',
      '4 parcelas mensais e sucessivas',
      '5 parcelas mensais e sucessivas',
      '6 parcelas mensais e sucessivas',
      '7 parcelas mensais e sucessivas',
      '8 parcelas mensais e sucessivas',
      '9 parcelas mensais e sucessivas',
      '10 parcelas mensais e sucessivas',
      '11 parcelas mensais e sucessivas',
      '12 parcelas mensais e sucessivas',
    ])
    .required('Atenção, Selecione a opção Efetue o pagamento em'),
};

export const declaracao = {
  declaracao: yup
    .bool()
    .oneOf([true], 'Atenção, Clique em Declaração')
    .required(),
};

export const declaracaoTipoRegime = {
  declaracaoTipoRegime: yup
    .bool()
    .oneOf([true], 'Atenção, Clique em Declaração')
    .required(),
};

export const aceiteInss = {
  aceiteInss: yup.bool().oneOf([true], 'Atenção, Clique em Declaração'),
};

export const aceiteAlteracaoDadosBancarios = {
  aceiteAlteracaoDadosBancarios: yup
    .bool()
    .oneOf([true], 'Atenção, Clique em Declaração'),
};

export const declaracaoCondicional = {
  declaracao: yup.bool().when('optoPor', {
    is: 'Continuar a receber o último percentual escolhido pelo participante',
    then: (field) =>
      field.oneOf([true], 'Atenção, Clique em Declaração').required(),
  }),
};
